import { render, staticRenderFns } from "./LoginRoblox.vue?vue&type=template&id=48e142b8&scoped=true"
import script from "./LoginRoblox.vue?vue&type=script&lang=js"
export * from "./LoginRoblox.vue?vue&type=script&lang=js"
import style0 from "./LoginRoblox.vue?vue&type=style&index=0&id=48e142b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e142b8",
  null
  
)

export default component.exports